const TransactionSpinner = () => (
    <svg
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='transaction-spinner'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4.98381 0.575361C6.29686 0.316452 7.65927 0.542552 8.8183 1.21172L8.12736 2.40847C7.25798 1.90653 6.23605 1.73693 5.25114 1.93114C4.26622 2.12534 3.38517 2.67017 2.77139 3.46456C2.15762 4.25895 1.85278 5.24898 1.91343 6.25103C1.97408 7.25308 2.39609 8.19912 3.10119 8.91369C3.80629 9.62825 4.74663 10.0628 5.74777 10.1368C6.74892 10.2108 7.74293 9.91924 8.54544 9.31612C9.34794 8.71299 9.90446 7.83927 10.1118 6.85704C10.3191 5.8748 10.1632 4.8507 9.67285 3.9747L10.8787 3.29978C11.5324 4.46764 11.7403 5.83293 11.4639 7.14242C11.1875 8.45191 10.4455 9.61672 9.37567 10.4208C8.30579 11.2249 6.98061 11.6136 5.6459 11.515C4.3112 11.4163 3.05758 10.8369 2.11756 9.88429C1.17754 8.93165 0.614924 7.67041 0.534072 6.33451C0.453219 4.99862 0.859616 3.67873 1.67788 2.61967C2.49615 1.56062 3.67075 0.834271 4.98381 0.575361Z'
            fill='white'
        />
    </svg>
);

export default TransactionSpinner;
